import { api } from '../axios.helper';
import {
  Config,
  HealthCareWorkerDto,
  PointsTodoItemDto,
  UserPointsAcitivtyDto,
} from '@ecdlink/core';
import {
  TeamStandingModel,
  UpdateHealthCareWorkerInputModelInput,
  UpdateHealthCareWorkerTabsInputModelInput,
} from '@ecdlink/graphql';

class HealthCareWorkerService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getHealthCareWorkerByUserId(): Promise<HealthCareWorkerDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'getHealthCareWorkerByUserId',
    });

    if (response.status !== 200) {
      throw new Error(
        'getHealthCareWorkerByUserId Failed - Server connection error'
      );
    }

    return response.data.data.healthCareWorkerByUserId;
  }

  async getHealthCareWorkerPoints(
    startDate: Date,
    endDate?: Date
  ): Promise<UserPointsAcitivtyDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { pointsForHealthCareWorker: UserPointsAcitivtyDto[] };
      errors?: {};
    }>(``, {
      id: 'getPointsForHealthCareWorker',
      variables: {
        startDate: startDate,
        endDate: endDate,
      },
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error(
        'pointsForHealthCareWorker Failed - Server connection error'
      );
    }

    return response.data.data.pointsForHealthCareWorker;
  }

  async getHealthCareWorkerTeamStanding(): Promise<TeamStandingModel> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { healthCareWorkerTeamStanding: TeamStandingModel };
      errors?: {};
    }>(``, {
      id: 'GetHealthCareWorkerTeamStanding',
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error('Get standing for user Failed - Server connection error');
    }

    return response.data.data.healthCareWorkerTeamStanding;
  }

  async getHealthCareWorkerPointsTodoItems(): Promise<PointsTodoItemDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { healthCareWorkerPointsTodoItems: PointsTodoItemDto[] };
      errors?: {};
    }>(``, {
      id: 'GetHealthCareWorkerPointsTodoItems',
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error(
        'Get points todo items for user Failed - Server connection error'
      );
    }

    return response.data.data.healthCareWorkerPointsTodoItems;
  }

  async updateHealthCareWorker(
    userId: string,
    input: UpdateHealthCareWorkerInputModelInput
  ): Promise<HealthCareWorkerDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateHealthCareWorker',
      variables: {
        userId,
        input,
      },
    });
    if (response.status !== 200) {
      throw new Error(
        'updateHealthCareWorker Failed - Server connection error'
      );
    }

    return response.data.data.updateHealthCareWorker;
  }

  async updateHealthCareWorkerTabs(
    input: UpdateHealthCareWorkerTabsInputModelInput,
    userId: string
  ): Promise<HealthCareWorkerDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { updateHealthCareWorkerTabs: HealthCareWorkerDto };
    }>(``, {
      id: 'UpdateHealthCareWorkerTabs',
      variables: {
        input,
        userId,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'updateHealthCareWorkerTabs failed - Server connection error'
      );
    }

    return response.data.data.updateHealthCareWorkerTabs;
  }

  async updateHealthCareWorkerWelcomeMessage(
    healthcareWorkerId: string,
    welcomeMessage: string,
    shareContactInfo: boolean
  ): Promise<HealthCareWorkerDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { updateHealthCareWorkerWelcomeMessage: HealthCareWorkerDto };
    }>(``, {
      id: 'UpdateHealthCareWorkerWelcomeMessage',
      variables: {
        healthcareWorkerId: healthcareWorkerId,
        welcomeMessage: welcomeMessage,
        shareContactInfo: shareContactInfo,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'updateHealthCareWorkerWelcomeMessage failed - Server connection error'
      );
    }

    return response.data.data.updateHealthCareWorkerWelcomeMessage;
  }
}

export default HealthCareWorkerService;
